import React from "react";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import PurchaseESimCart from "./PurchaseESimCart";
import PurchaseESim from "./PurchaseESim";
import PurchaseESimBanner from "../../reusable/PurchaseESimBanner";
import ESimCompatible from "../../reusable/ESimCompatible";
import {PulseLoader} from "react-spinners";
import Checkout from "../checkout";
import LoginPage from "../login";
import {connect} from "react-redux";

class PurchaseDevice extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			associatedProduct: null,
            recurringProfile: null            
        };

        console.log("contructorProps", this.props);
    }

	setProduct = (product) => {
        this.setState({
            associatedProduct: product
        });
    };

	setProfile = (profile) => {
        this.setState({
            recurringProfile: profile
        });
    };

    render(){
        const { auth } = this.props;
        const showMainPage = this.state.associatedProduct && this.state.recurringProfile ? true : false;
        //if (typeof this.props.location.state !== "undefined" && typeof this.props.location.state.promotion !== "undefined") {
        if (typeof this.props.location.state !== "undefined" &&
            typeof this.props.location.state.promotion !== "undefined" &&
            typeof this.props.location.state.buy_option !== "undefined" &&
            typeof this.props.location.state.useType !== "undefined") {
            if (auth.isAuthenticated) {
                if(typeof this.props.cart.cart !== 'undefined' && typeof this.props.cart.cart.product !== 'undefined') {
                    //this.props.cart.cart.product.image = "/images/mightywifi-cloud-" + this.props.location.state.color.toLowerCase() + ".png";
                    this.props.cart.cart.product.color = this.props.location.state.color;
                    this.props.cart.cart.color = this.props.location.state.color;
                }
                return (
                    <div>
                        <PulseLoader
                            className="sweet-loading"
                            sizeUnit={"px"}
                            size={20}
                            color={"#123abc"}
                            loading="true"
                        />
                        <Checkout/>

						{showMainPage ? (
                            <PurchaseESimCart
  							    product={this.state.associatedProduct}
						        profile={this.state.recurringProfile}
								setProduct={this.setProduct}
	                            setProfile={this.setProfile}
					 	    />
                        ) : (
						<PurchaseESim
							setProduct={this.setProduct}
                            setProfile={this.setProfile}
						/>
                        )}
                    </div>
                );
            }
            else {
                return (
                    <div>
                        <PulseLoader
                            className="sweet-loading"
                            sizeUnit={"px"}
                            size={20}
                            color={"#123abc"}
                            loading="true"
                        />
                        <LoginPage/>
                        {showMainPage ? (
                            <PurchaseESimCart
  							    product={this.state.associatedProduct}
						        profile={this.state.recurringProfile}
								setProduct={this.setProduct}
	                            setProfile={this.setProfile}
					 	    />
                        ) : (
                            <PurchaseESim
								setProduct={this.setProduct}
								setProfile={this.setProfile}
							/>
                        )}
                    </div>
                );
            }
        }
        else {
            return (
                <div>
                    <PurchaseESimBanner/>
                    {showMainPage ? (
                        <PurchaseESimCart
  						    product={this.state.associatedProduct}
						    profile={this.state.recurringProfile}
							setProduct={this.setProduct}
                            setProfile={this.setProfile}
					 	/>
                    ) : (
                        <PurchaseESim
							setProduct={this.setProduct}
							setProfile={this.setProfile}
						/>
                    )}
                    <ESimCompatible/>
                    <AnyQuestions/>
                    <StayTouch/>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart
    };
}

//export default layoutWrapper(PurchaseDevice);
//export default connect(mapStateToProps)(PurchaseDevice);
export default connect(mapStateToProps)(layoutWrapper(PurchaseDevice));



// WEBPACK FOOTER //
// ./src/pages/purchaseESim/index.js